var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dcd5f2",
    d: "M1.5 14.5L1.5 1.5 11.793 1.5 14.5 4.207 14.5 14.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b75a1",
    d: "M11.586,2L14,4.414V14H2V2H11.586 M12,1H1v14h14V4L12,1L12,1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 8H12V14H4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c6bae6",
    d: "M11,2H4v3c0,0.552,0.448,1,1,1h6V2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1ebf2",
    d: "M6,5.5C5.725,5.5,5.5,5.276,5.5,5V2c0-0.276,0.225-0.5,0.5-0.5h5c0.275,0,0.5,0.224,0.5,0.5v3 c0,0.276-0.225,0.5-0.5,0.5H6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#66798f",
    d: "M11,2v3H6V2H11 M11,1H6C5.448,1,5,1.448,5,2v3c0,0.552,0.448,1,1,1h5c0.552,0,1-0.448,1-1V2 C12,1.448,11.552,1,11,1L11,1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2e8ff",
    d: "M5 10H11V11H5zM5 12H11V13H5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#788b9c",
    d: "M9 3H10V5H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8603ac0b4df90943cb355eea0e617786.svg";
export { ForwardRef as ReactComponent };